import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scroll to top on every route change.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [pathname]);
  return null;
}
